export const MAPPING_TYPE_CONFIG = [
	{
		mappingId: 2,
		label: 'Factory RM Issue Schedule',
		color: '#380000ff',
		icon: '📋',
		defaultValue: 'T',
	},
	{
		mappingId: 3,
		label: 'Factory Yield Measurement Schedule',
		color: '#380000ff',
		icon: '🏷️',
		defaultValue: 'T',
	},
	{
		mappingId: 8,
		label: 'Non-Traceable SKUs(Skip Yield)',
		color: '#380000ff',
		icon: '⚫',
		defaultValue: 'No',
	},
	{
		mappingId: 20,
		label: 'Factory Kit Issue Layout',
		color: '#380000ff',
		icon: '📦',
		defaultValue: 'Same as Yeild Process',
	},
	{
		mappingId: 21,
		label: 'Enable Batch Management',
		color: '#380000ff',
		icon: '🔗',
		defaultValue: 'No',
	},
];
